import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { ClipboardPlus, X } from "lucide-react";
import InterventionTracker from "@/pages/main/InterventionTracker";

/**
 * Slide-out wrapper around the full-page InterventionTracker so paramedics
 * can pop it open from anywhere in the app and instantly return to their
 * previous workflow (a protocol page, calculator, etc.) by closing the
 * sheet. Same component, just rendered inside a sheet panel.
 */
export default function InterventionTrackerSheet({ trigger }) {
  const [open, setOpen] = useState(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <span onClick={() => setOpen(true)} className="contents" data-testid="intervention-tracker-trigger">
        {trigger}
      </span>
      <SheetContent
        side="right"
        className="w-full sm:max-w-2xl p-0 overflow-y-auto"
        aria-describedby={undefined}
      >
        <SheetHeader className="sticky top-0 bg-background z-20 border-b px-4 py-3 flex flex-row items-center justify-between space-y-0">
          <SheetTitle className="font-heading text-lg flex items-center gap-2">
            <ClipboardPlus className="w-5 h-5 text-emerald-500" />
            Intervention Tracker
          </SheetTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setOpen(false)}
            className="gap-1 h-8"
            data-testid="close-intervention-tracker"
          >
            <X className="w-4 h-4" />
            Close
          </Button>
        </SheetHeader>
        <div className="p-4">
          {/* Render the full tracker inside the sheet */}
          <InterventionTracker embedded />
        </div>
      </SheetContent>
    </Sheet>
  );
}
